import { render } from "./Laboratories.vue?vue&type=template&id=d8aa4ee6&scoped=true"
import script from "./Laboratories.vue?vue&type=script&lang=js"
export * from "./Laboratories.vue?vue&type=script&lang=js"

import "./Laboratories.vue?vue&type=style&index=0&id=d8aa4ee6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8aa4ee6"]])

export default __exports__